import { defineMessages } from 'react-intl';

export default defineMessages({
    lblAgencyEmail: {
        id: 'app.shopping.createBooking.Passenger.AgencyEmail',
        defaultMessage: 'Agency Email',
    },
    lblNone: {
        id: 'app.shopping.createBooking.Passenger.None',
        defaultMessage: 'None',
    },
    lblOther: {
        id: 'app.shopping.createBooking.Passenger.Other',
        defaultMessage: 'Other',
    },
});
